import { useLocation } from 'react-router-dom';
import {
  isInspectionChecklistPath,
  isInspectionDetailsPath,
  isInspectionEditPath,
  isInspectionTemplatePath,
  isIssueDetailsPath,
  isIssueEventPath,
} from 'setup/navigation/routeMatchers';

export enum EntityOnProjectRoute {
  issue = 'issue',
  event = 'event',
  file = 'file',
  directory = 'directory',
  template = 'template',
  inspection = 'inspection',
}

export function chooseEntity(
  location: ReturnType<typeof useLocation>
): EntityOnProjectRoute | undefined {
  if (location.pathname.includes('documentation/file')) {
    return EntityOnProjectRoute.file;
  }
  if (location.pathname.includes('documentation/dir')) {
    return EntityOnProjectRoute.directory;
  }
  if (location.pathname.includes('documentation')) {
    return EntityOnProjectRoute.directory;
  }
  if (isIssueEventPath(location.pathname)) {
    return EntityOnProjectRoute.event;
  }
  if (isIssueDetailsPath(location.pathname)) {
    return EntityOnProjectRoute.issue;
  }
  if (isInspectionTemplatePath(location.pathname)) {
    return EntityOnProjectRoute.template;
  }
  if (
    isInspectionDetailsPath(location.pathname) ||
    isInspectionEditPath(location.pathname) ||
    isInspectionChecklistPath(location.pathname) ||
    location.pathname.includes('/inspection/')
  ) {
    return EntityOnProjectRoute.inspection;
  }

  return undefined;
}
